import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Modal from "react-modal";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import SearchBar from "../../../common-components/SearchBar";
import { selectToken } from "../../../auth/auth.selector";
import {
  fetchAllDietPackagesData,
  fetchMembersByIdData,
  fetchUserDetailsByMobileData,
} from "../../../../redux/reducers/apiSlice";
import MemberDetails from "../../common/MemberDetails";
import { dietAssign } from "../../../../redux/reducers/postApiSlice";
import ViewGoalDiets from "../../dietPackage/ViewGoalDiets";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PayoutsTable from "../../../components-bootstrap/PayoutsTable";
import { formattedLongDate } from "../../../common-data/Converts";
import { fetchDietPakagesDropdwonData } from "../../../../redux/reducers/dropdownApiSlice";
import SelectDropdown from "../../../components-react/SelectDropdown";
import { showConfirmAlert } from "../../../components-react/ReactAlert";

const AssignDiet = ({ onClose, rowData, callFunction, isExternal }) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);

  const { loading, userDetailsByMobile, memberById, dietPackagesData } =
    useSelector((state) => state.api);
  const { dietPackagesDropdown } = useSelector((state) => state.dropdown);

  const { is_paid, uid, user_id } = rowData || {};

  const [searchString, setSearchString] = useState("");
  const iniADform = {
    isUser: false,
    userProfile: null,
    userMobile: "",
    userName: "",
    userEMail: "",
    gymName: "",
    userId: "",
    currentPlanDetails: null,
    startDate: "",
    membershipDetails: {},
    isFitnessProfile: false,
    prevDietDetails: [],
    isPlanExist: false,
    selectedDietPackage: "",
  };
  const [formValues, setFormValues] = useState(iniADform);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [viewModal, setViewModa] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);
    setFormValues((prev) => ({
      ...prev,
      [name]: type === checked ? checked : value,
    }));
  };

  const onChangeSearch = (e) => {
    const { value } = e.target;
    setSearchString(value);

    setFormValues(iniADform);
  };

  const onChangeDropdown = (value, name) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const onClickSearch = (searchString) => {
    if (searchString) {
      setIsSearch(true);
    } else {
      setIsSearch(false);
      toast.error("Please enter name/mobile to begin search!");
    }
  };

  const onCloseModal = () => {
    setIsSubmit(false);
    setIsSearch(false);
    setFormValues(iniADform);
    setSearchString("");
    onClose();
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (isExternal) {
      if (!formValues.selectedDietPackage) {
        toast.error("Select Diet Package!");
        return;
      } else if (
        formValues.selectedDietPackage?.info?.is_paid &&
        formValues.selectedDietPackage?.info?.user_id !== formValues.userId
      ) {
        toast.error("Oops🙊... This Diet Package Is Created For Other User!");
        return;
      }
    } else if (!isExternal) {
      if (is_paid && user_id !== formValues.userId) {
        toast.error("Oops🙊... This Diet Package Is Created For Other User!");
        return;
      }
    }

    if (!formValues.startDate) {
      toast.error("Enter Start Date!");
      return;
    } else {
      setIsSubmit(true);
    }
  };

  const handleAssignDiet = async (requestBody, TOKEN) => {
    try {
      const actionResult = dispatch(dietAssign({ requestBody, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        onCloseModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAssignDiet ERROR => ", error);
    }
  };

  useEffect(() => {
    if (isExternal) {
      dispatch(
        fetchDietPakagesDropdwonData({
          token: token,
          qps: `&search=${searchString}`,
          pageNo: 1,
          limit: 1000,
        })
      );
    }
  }, [isExternal]);

  useEffect(() => {
    if (isSearch) {
      dispatch(
        fetchUserDetailsByMobileData({
          userMobile: "",
          token: token,
          qps: `&search=${searchString}`,
        })
      );
    }
  }, [isSearch]);

  useEffect(() => {
    if (
      isSearch &&
      userDetailsByMobile?.status &&
      userDetailsByMobile?.data?.length > 0
    ) {
      const { data } = userDetailsByMobile || {};
      const dataLength = data?.length;
      const { account_type, name, mobile, email, gym_name, profile, uid } =
        data[0] || {};
      // setIsSearch(false);

      if (dataLength === 1 && account_type === "member") {
        setFormValues((prevs) => ({
          ...prevs,
          isUser: true,
          userProfile: profile,
          userMobile: mobile,
          userName: name,
          userEMail: email,
          gymName: gym_name,
          userId: uid,
        }));

        if (uid) {
          dispatch(
            fetchMembersByIdData({
              memId: uid,
              queryParameters: "",
              token: token,
            })
          );
        }
      } else if (dataLength !== 1) {
        toast.error(
          "Please enter full name or phone number to find specific user!"
        );
        setFormValues(iniADform);
      } else if (account_type !== "member") {
        toast.error("User account type is not member!!");
        setFormValues(iniADform);
      } else if (dataLength === 1 && account_type === "member") {
        setFormValues(iniADform);
      }
    } else {
      setFormValues(iniADform);
    }
  }, [userDetailsByMobile]);

  useEffect(() => {
    if (isSearch && memberById?.status && memberById?.data) {
      const { diet_category_id, is_completed } = memberById.data || {};

      // console.log(" memberById.data=> ", memberById.data);

      // if (is_completed) {
        if (diet_category_id) {
          dispatch(
            fetchAllDietPackagesData({
              pageNo: 1,
              limit: 1,
              queryParameters: `status=active&uid=${diet_category_id}`,
              token: token,
            })
          );
          setFormValues((prevs) => ({
            ...prevs,
            membershipDetails: memberById.data,
            isFitnessProfile: true,
          }));
        } else {
          setFormValues((prevs) => ({
            ...prevs,
            membershipDetails: {},
            isFitnessProfile: true,
          }));
        }
      // } else {
      //   toast.error("This User Fitness Profile Is Not Completed!");
      //   setFormValues((prevs) => ({
      //     ...prevs,
      //     membershipDetails: {},
      //     isFitnessProfile: false,
      //   }));
      //   return;
      // }
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        membershipDetails: {},
        isFitnessProfile: false,
      }));
    }
  }, [memberById]);

  useEffect(() => {
    if (
      isSearch &&
      dietPackagesData?.status &&
      dietPackagesData?.data?.length > 0
    ) {
      const { data } = dietPackagesData || {};

      setFormValues((prevs) => ({
        ...prevs,
        prevDietDetails: data,
        isPlanExist: true,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        prevDietDetails: [],
        isPlanExist: false,
      }));
    }
  }, [dietPackagesData]);

  console.log(" formValues.membershipDetails=> ",  formValues.membershipDetails);

  useEffect(() => {
    if (isSubmit) {
      setIsSubmit(false);

      const requestBody = {
        user_id: formValues.userId,
        diet_category_id: isExternal
          ? formValues.selectedDietPackage?.value
          : uid,
        subscription_id:
          formValues.membershipDetails?.regular_subscription_id || "",
        is_free: formValues.membershipDetails?.regular_subscription_id ? 0 : 1,
        is_complementry: formValues.membershipDetails?.regular_subscription_id
          ? 1
          : 0,
        start_date: formValues.startDate,
      };

      const handleConfirm = async () => {
        handleAssignDiet(requestBody, token);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Assign Diet"
      );
    }
  }, [isSubmit]);

  useEffect(() => {
    if (searchString?.length === 0) {
      setIsSearch(false);
    }
  }, [searchString]);

  const dietPackageCols = [
    {
      dataField: "name",
      text: "name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data bold minWidth150">{row?.name || "NA"}</span>
        );
      },
    },
    {
      dataField: "diet_cat_type",
      text: "Diet Category",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.diet_cat_type || "NA"}</span>;
      },
    },
    {
      dataField: "type2_name",
      text: "Body Preference",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.type2_name || "NA"}</span>;
      },
    },
    {
      dataField: "duration",
      text: "duration",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.duration || "0"} Day(S)</span>;
      },
    },
    {
      dataField: "is_paid",
      text: "Free/Paid",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.is_paid === 1 ? "Paid" : row?.is_paid === 0 ? "Free" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "user name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.diet_cat_type === "custom" ? row?.user_name : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "min_cal",
      text: "Calorie range",
      formatter: (cell, row) => (
        <div className="multi-tb-data-range minWidth90">
          <span className="tb-data">{row?.min_cal || "0"}</span> -{" "}
          <span className="tb-data">{row?.max_cal || "0"}</span>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">
            {row?.date_added ? formattedLongDate(+row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon view"
            type="button"
            onClick={() => setViewModa(true)}
            style={{
              border:
                row?.goal_diet?.length > 0
                  ? "1px solid #bc0909"
                  : "1px solid #9C9C9C",
              color: row?.goal_diet?.length > 0 ? "#bc0909" : "#9C9C9C",
              borderRadius: "12px",
              cursor: row?.goal_diet?.length > 0 ? "pointer" : "not-allowed",
            }}
            disabled={row?.goal_diet?.length === 0}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrows-angle-expand"
              viewBox="0 0 16 16"
              style={{
                color: row?.goal_diet?.length > 0 ? "#bc0909" : "#9C9C9C",
              }}
            >
              <path
                fillRule="evenodd"
                d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={viewModal}
        onRequestClose={() => {
          setViewModa(false);
        }}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer paymentDetailsModalContainer">
          <ModalHeadAndClose
            title="Diet Details (View Only)"
            onClose={() => {
              setViewModa(false);
            }}
          />

          <div className="fullWidthFlexCenter">
            <ViewGoalDiets rowData={formValues.prevDietDetails?.[0]} />
          </div>
        </div>
      </Modal>

      <div className="createNewCTOModalContainer mealsModalContainer addIngModal">
        <ModalHeadAndClose
          title={`Assign diet : ${rowData?.name || ""}`}
          onClose={() => onCloseModal()}
        />
        <div className="grayLine"></div>

        <form className="formContainer">
          <div className="formInputsGrid">
            <div className="formInputBox span2">
              <label htmlFor="tpName" className={`formInputLabel `}>
                Search member by name or mobile *
              </label>

              <SearchBar
                searchString={searchString}
                onChangeSearch={onChangeSearch}
                onClickSearch={onClickSearch}
                loading={loading}
              />

              {formValues.isPlanExist && (
                <span className="info">User is already on a diet plan</span>
              )}
            </div>
          </div>

          {formValues.isUser && <MemberDetails userData={formValues} />}

          {formValues.isPlanExist && (
            <div className="fullWidthFlexCenter overflowAuto separatedTable  mt30">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <PayoutsTable
                  columnsValues={dietPackageCols}
                  dataValues={formValues.prevDietDetails || []}
                />
              )}
            </div>
          )}

          {formValues.userId && formValues.isFitnessProfile && (
            <>
              <div className="formInputsGrid">
                {isExternal && (
                  <div className="formInputBox">
                    <label
                      htmlFor="selectedDietPackage"
                      className={`formInputLabel`}
                    >
                      Diet Package *
                    </label>
                    <div className={`commonWrapper`}>
                      <SelectDropdown
                        options={dietPackagesDropdown}
                        selectedOption={formValues.selectedDietPackage}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown(selectedValue, "selectedDietPackage")
                        }
                        name="Diet Package"
                      />
                    </div>
                  </div>
                )}

                {/* <div className="formInputsGrid"> */}
                <div className="formInputBox span2">
                  <label htmlFor="startDate" className={`formInputLabel `}>
                    Select starting date *
                  </label>

                  <input
                    type="date"
                    className={`formInput ${
                      formValues.startDate ? "date-has-value" : ""
                    }`}
                    name="startDate"
                    value={formValues.startDate}
                    onChange={onChangeInput}
                  />
                </div>
                {/* </div> */}
              </div>

              <div className="formButtons flexSpacebetween">
                {formValues.isPlanExist && (
                  <span className="error">
                    Current plan will be replaced by the selected plan
                  </span>
                )}

                <Button
                  className="saveBtn"
                  variant="danger"
                  onClick={(e) => onSubmit(e)}
                >
                  Assign
                </Button>
              </div>
            </>
          )}
        </form>
      </div>
    </>
  );
};

export default AssignDiet;
